/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../../../platform/Platform';
import {
  ComponentManager,
  ComponentManagerFn,
} from '../../../../registry/Component.type';
import { ItemType } from '../../../../registry/ComponentRegistry';
import { baseComponentManager } from '../../../../registry/Components';
import { ProgressIndicatorProps } from '../../../ProgressIndicator/ProgressIndicatorManager';
import { baseColumnProps, isBaseColumnPropertyVisible } from '../BaseColumn';
import { defaultValue } from './ProgressIndicatorColumn';

const ProgressIndicatorColumnManager: ComponentManagerFn<
  'ProgressIndicatorColumn'
> = (platform: Platform): ComponentManager<'ProgressIndicatorColumn'> => {
  return {
    ...baseComponentManager<'ProgressIndicatorColumn'>(
      platform,
      'ProgressIndicatorColumn',
    ),
    type: 'ProgressIndicatorColumn',
    name: 'Progress Indicator Column',
    isChildAllowed: (page, item, childType) =>
      (['TriggerOnCellClick'] as ItemType[]).includes(childType),
    defaultValue,
    props: {
      ...baseColumnProps,
      ...ProgressIndicatorProps,
    },
    isPropertyVisible(prop, { type }, { appUid, itemId, pageId }): boolean {
      if (
        itemId &&
        !isBaseColumnPropertyVisible({
          appUid,
          platform,
          itemId,
          pageId,
          prop,
        })
      ) {
        return false;
      }
      switch (prop) {
        case 'alignment':
        case 'bgColorExpression':
        case 'colorExpression':
          return false;
        case 'size':
        case 'thickness':
        case 'fontSize':
          return type === 'circular';
        case 'linearWidth':
          return false; // column width will be used
        default:
          return true;
      }
    },
    getDisplayText: (item) =>
      typeof item.props.label === 'string'
        ? item.props.label
        : item.props.label.value ?? '',
    replaceableWith: ['StarColumn', 'NumberColumn'],
    category: 'Data Grid',
    icon: { iconName: 'percentage' },
  };
};

export default ProgressIndicatorColumnManager;
